import React from 'react';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent.typed';
import {AutoDeliveryPaymentInfo} from '@/types/icc/autoDeliveryDetails';
import stringUtils from '@/utils/stringUtils';

import AutoDeliveryDcxSection from './AutoDeliveryDcxSection';
import AutoDeliveryDcxSectionButton from './AutoDeliveryDcxSectionButton';

interface AutoDeliveryDcxPaymentMethodProps {
    className?: string;
    isUpdateDisabled?: boolean;
    paymentInfo?: AutoDeliveryPaymentInfo;
}

const AutoDeliveryDcxPaymentMethod = ({
    className,
    isUpdateDisabled,
    paymentInfo,
}: AutoDeliveryDcxPaymentMethodProps) => {
    const content = appContent.getAutoDeliveryContent()?.extendedDetailsContent;

    if (!content || !paymentInfo) return null;

    const {expiryMonth, expiryYear, cardNumber, cardType} = paymentInfo;

    if (!cardNumber) return null;

    const {
        paymentCardNumberLabel,
        paymentMethodExpiresLabel,
        paymentMethodTitle,
        paymentMethodUpdateButton,
        paymentMethodCardTypes,
    } = content;
    const cardNumberLabel = stringUtils.formatString(paymentCardNumberLabel, cardNumber?.slice(-4) ?? '');
    const expiresLabel = stringUtils.formatString(paymentMethodExpiresLabel, expiryMonth ?? '', expiryYear ?? '');
    const paymentCardIcon = paymentMethodCardTypes?.find((card) => card.code === cardType?.code)?.icon;
    const hasExpireDate = expiryMonth && expiryYear;

    return (
        <AutoDeliveryDcxSection
            className={className}
            title={paymentMethodTitle}
            action={<AutoDeliveryDcxSectionButton button={paymentMethodUpdateButton} disabled={isUpdateDisabled} />}
        >
            <div className='mt-4 flex items-center gap-2'>
                {paymentCardIcon && (
                    <div className='h-6 w-11 self-start rounded-[2.25px] border-[0.75px] border-french-gray'>
                        <RemoteIconV2 icon={paymentCardIcon} className='h-full w-full' />
                    </div>
                )}
                <div>
                    <p className='text-16 leading-[24px] tracking-02'>{cardNumberLabel}</p>
                    {hasExpireDate && (
                        <p className='mt-2 text-14 leading-[20px] tracking-02 text-primary-dark-85'>{expiresLabel}</p>
                    )}
                </div>
            </div>
        </AutoDeliveryDcxSection>
    );
};

export default AutoDeliveryDcxPaymentMethod;
